module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"hello":"Hallo Welt!"},"fr":{"hello":"Salut le monde!"}}')
  delete Component.options._Ctor
}
